import axios from 'axios';
import store from '@/store';
import i18n from '@/i18n';
import { campaignActionUrl } from './url';
export async function getCampaignDetails(id) {
    const brand = store.getters.selectedBrand;
    const tokenV3 = store?.state?.auth?.tokenV3 ?? '';
    const url = campaignActionUrl(id);
    if (!brand?.id) {
        throw new Error(i18n.global.t('breadcrumb.email.campaigns.errors.brand-id-not-available'));
    }
    if (!tokenV3) {
        throw new Error(i18n.global.t('breadcrumb.email.campaigns.errors.auth-token-not-available'));
    }
    const res = await axios.get(url, {
        params: { brand_id: brand.id },
        ...(tokenV3 && { headers: { Authorization: `Bearer ${tokenV3}` } }),
    });
    return res.data;
}
